// extracted by mini-css-extract-plugin
module.exports = {"beautonomy":"styles_beautonomy__5mJjh","smartcenter":"styles_smartcenter__CnP2D"};